import { FC } from 'react';
import { Typography, Tooltip } from '@mui/material';
import { HelpOutlineOutlined as HelpOutlineOutlinedIcon } from '@mui/icons-material';

import { CardContent, CardHeader } from './Card';
import CollapsibleCard, { CollapsibleCardProps } from '../../../../../components/Card/CollapsibleCard/CollapsibleCard';
import CollapsibleCardExpandArea from '../../../../../components/Card/CollapsibleCard/CollapsibleCardExpandArea';
import CollapsibleCardExpandButton from '../../../../../components/Card/CollapsibleCard/CollapsibleCardExpandButton';
import Row from '../../../../../components/Row';

import { Campaign } from '../../../../../types/Campaign';
import CampaignOverviewList from '../List/CampaignOverviewList';

interface CampaignOverviewCardProps {
    campaign: Campaign;
    slotProps?: {
        collapsibleCard?: Partial<CollapsibleCardProps>;
    };
}

const CampaignOverviewCard: FC<CampaignOverviewCardProps> = ({ campaign, slotProps = {} }) => {
    return (
        <CollapsibleCard
            defaultExpanded
            {...slotProps?.collapsibleCard}
            sx={{
                '& .MuiCardContent-root:last-child': {
                    p: 0,
                },
            }}
        >
            <CardHeader
                title={
                    <Row alignItems="center" gap={1}>
                        <Typography variant="body1">Campaign Overview</Typography>
                        <Tooltip title="Campaign Details">
                            <HelpOutlineOutlinedIcon fontSize="small" color="action" />
                        </Tooltip>
                    </Row>
                }
                action={<CollapsibleCardExpandButton />}
            />
            <CollapsibleCardExpandArea>
                <CardContent sx={{ p: 0 }}>
                    <CampaignOverviewList campaign={campaign} />
                </CardContent>
            </CollapsibleCardExpandArea>
        </CollapsibleCard>
    );
};

export default CampaignOverviewCard;
